import React from 'react';
export function CTABanner() {
  return <section className="bg-primary relative overflow-hidden py-20" data-id="element-21">
      {/* Abstract background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-22">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-white opacity-5 rounded-full blur-3xl" data-id="element-23"></div>
        <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-white opacity-10 rounded-full blur-3xl" data-id="element-24"></div>
      </div>

      <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center z-10" data-id="element-25">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-26">
          Stop overpaying for telecom. Start saving today.
        </h2>
        <p className="text-xl text-blue-100 mb-10 max-w-2xl mx-auto" data-id="element-27">
          Get a free expense analysis in just 30 minutes. We'll show you exactly
          where you're overspending and how much you can save.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-28">
          <a href="#quote" className="w-full sm:w-auto bg-white text-primary hover:bg-slate-50 px-8 py-4 rounded-full font-bold text-lg transition-colors shadow-lg" data-id="element-29">
            Get Your Free Analysis
          </a>
          <a href="tel:+4105255284" className="w-full sm:w-auto bg-transparent border-2 border-white text-white hover:bg-white/10 px-8 py-4 rounded-full font-bold text-lg transition-colors" data-id="element-30">
            Call Us: +410-525-5284
          </a>
        </div>
      </div>
    </section>;
}